<div class="col-xs-12" ng-class="vm.faixaClass()">
  <div no-ui-slider
       id="uiSlider{{vm.indicador.id}}"
       slider-options="vm.optionsWithoutStart"
       ng-model="vm.indicador.faixas"
       slider-created="vm.onSliderCreated(api)"
       ng-if="vm.showFaixas"></div>
</div>
<div ng-class="vm.faixaClass()" ng-if="vm.indicador.numero_faixas===3">
  <div class="col-xs-4 text-center">
    <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
    <b> &lt;= {{vm.indicador.faixas[0] | number:0}}</b>
  </div>
  <div class="col-xs-4 text-center">
    <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[0] | number:0}} e &lt;= {{vm.indicador.faixas[1] | number:0}}</b>
  </div>
  <div class="col-xs-4 text-center">
    <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[1] | number:0}}</b>
  </div>
</div>
<div ng-class="vm.faixaClass()" ng-if="vm.indicador.numero_faixas===4">
  <div class="col-xs-3 text-center no-padding">
    <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
    <b> &lt;= {{vm.indicador.faixas[0] | number:0}}</b>
  </div>
  <div class="col-xs-3 text-center no-padding">
    <span class="bg-alto_equilibrio padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[0] | number:0}} e &lt;= {{vm.indicador.faixas[1] | number:0}}</b>
  </div>
  <div class="col-xs-3 text-center no-padding">
    <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[1] | number:0}} e &lt;= {{vm.indicador.faixas[2] | number:0}}</b>
  </div>
  <div class="col-xs-3 text-center no-padding">
    <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[2] | number:0}}</b>
  </div>
</div>
<div ng-class="vm.faixaClass()" ng-if="vm.indicador.numero_faixas===5">
  <div class="col-xs-3 text-center no-padding">
    <span class="bg-equilibrio padding-left-5 padding-right-5">&nbsp;</span>
    <b> &lt;= {{vm.indicador.faixas[0] | number:0}}</b>
  </div>
  <div class="col-xs-2 text-center no-padding">
    <span class="bg-alto_equilibrio padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[0] | number:0}} e &lt;= {{vm.indicador.faixas[1] | number:0}}</b>
  </div>
  <div class="col-xs-2 text-center no-padding">
    <span class="bg-controle padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[1] | number:0}} e &lt;= {{vm.indicador.faixas[2] | number:0}}</b>
  </div>
  <div class="col-xs-2 text-center no-padding">
    <span class="bg-alerta padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[2] | number:0}} e &lt;= {{vm.indicador.faixas[3] | number:0}}</b>
  </div>
  <div class="col-xs-2 text-center no-padding">
    <span class="bg-extremo padding-left-5 padding-right-5">&nbsp;</span>
    <b> > {{vm.indicador.faixas[3] | number:0}}</b>
  </div>
</div>
